export default {
  ContinueBtn: 'Tiếp tục',
  HandoverBtn: 'Bàn giao',
  HandoverSuccess: 'Bàn giao công việc thành công',
  HandoverDuplicateUser:
    'Người bàn giao và người nhận bàn giao không thể trùng nhau',
  NullHandoverFromUser:
    'Bạn cần chọn người cần bàn giao trước khi chọn người được bàn giao',
  HandoverTask: 'Điều phối bàn giao',
  CloseTooltip: 'Đóng (ESC)',
  EndSession: 'Phiên đăng nhập đã hết. Vui lòng đăng nhập lại.',
  TaskList: 'Danh sách công việc',
  NotifyEmpty: 'Chưa có thông báo nào',
  MarkReadAllNotify: 'Đánh dấu tất cả là đã đọc',
  noData: 'Không có dữ liệu',
  EmptyData: 'Chưa có dữ liệu',
  search: 'Tìm kiếm...',
  FeaturesIsDeveloping: 'Tính năng đang phát triển',
  ImplementationDate: 'Ngày thực hiện',
  TaskDeadLine: 'Hạn hoàn thành',
  TaskExecutorAndCombination: 'Người chủ trì và phối hợp',
  TaskDeadLineTime: 'Giờ kết thúc',
  TaskDeadLineStartTime: 'Giờ bắt đầu',
  TaskDeadLineStartDate: 'Ngày bắt đầu',
  TaskDeleted: 'Công việc đã bị xóa',
  RemindDate: 'Ngày nhắc việc',
  RemindTime: 'Giờ nhắc việc',
  Time: 'Thời gian',
  Role: 'Vai trò',
  OrgUnit: 'Đơn vị',
  MarkDoneSuccess: 'Đánh dấu hoàn thành công việc thành công',
  MarkDoneApproval: 'Phê duyệt công việc',
  SettingRemind: 'Thiết lập thời hạn nhắc việc',
  ExportProcessing: 'tiến trình đang xử lý',
  LoadingProcessingName: 'Xuất khẩu {name} đang xử lý',
  SuccessProcessingName: 'Xuất khẩu {name} đã hoàn thành',
  FailureProcessingName: 'Xuất khẩu {name} lỗi',
  Handover: {
    step1Txt: 'Chọn người cần bàn giao và người được bàn giao',
    step2Txt: 'Chọn công việc cần bàn giao'
  },
  command: {
    apply: 'Áp dụng',
    startTourGuide: 'Bắt đầu khám phá',
    selectProfileQLCB: 'Lấy từ hồ sơ MISA QLCB',
    sort: 'Sắp xếp',
    add: 'Thêm',
    addUser: 'Thêm người',
    edit: 'Sửa',
    update: 'Cập nhật',
    delete: 'Xóa',
    deleteField: 'Xóa thông tin',
    duplicate: 'Nhân bản',
    more: 'Thêm nữa...',
    actionMore: 'Chức năng khác',
    save: 'Lưu',
    saveChange: 'Lưu thay đổi',
    saveNew: 'Lưu & Thêm',
    saveData: 'Lưu dữ liệu thành công',
    sendApproval: 'Gửi phê duyệt thành công',
    invalidExecutor: 'Bạn không có quyền thực hiện hành động này',
    canNotDeleteTaskType: 'Không thể xóa giá trị loại việc',
    canNotDeletePriorityLevel: 'Không thể xóa giá trị mức độ ưu tiên',
    sendApprovalFail: 'Gửi phê duyệt thất bại',
    revokeFail:
      'Không thể thu hồi công việc do Người giao việc đã phê duyệt công việc này',
    revokeApproval: 'Thu hồi phê duyệt thành công',
    cancelApprovalSuccess: 'Hủy phê duyệt công việc thành công',
    approveTaskSuccess: 'Đồng ý phê duyệt công việc thành công',
    addCommentTask: 'Thêm nhận xét thành công',
    addReasonTask: 'Thêm lý do từ chối thành công',
    rejectTask: 'Từ chối phê duyệt công việc thành công',
    approveTaskFail:
      'Không thể phê duyệt công việc do Người chủ trì đã thu hồi yêu cầu phê duyệt',
    approveTaskFailByTaskOutOfTime:
      'Không thể phê duyệt công việc do công việc vượt quá hạn cho phép',
    close: 'Đóng',
    hide: 'Ẩn',
    help: 'Giúp',
    cancel: 'Hủy',
    cancel2: 'Không',
    accept: 'Đồng ý',
    reject: 'Từ chối',
    saveAndNew: 'Lưu và thêm mới',
    send: 'Gửi',
    continue: 'Tiếp tục',
    understand: 'Tôi đã hiểu',
    sendTaskApproval: 'Gửi phê duyệt',
    waitApproval: 'Chờ phê duyệt',
    revokeTaskApproval: 'Thu hồi',
    cancelApproval: 'Hủy phê duyệt',
    cancelDoneTask: 'Huỷ đánh dấu hoàn thành',
    approveTask: 'Phê duyệt công việc',
    markDoneTask: 'Đánh dấu hoàn thành',
    reviewTask: 'Đánh giá và nhận xét công việc',
    confirm: 'Xác nhận',
    notConfirm: 'Không xác nhận',
    export: 'Xuất khẩu',
    finish: 'Hoàn thành',
    load: 'Nạp',
    print: 'In',
    filter: 'Lọc',
    refresh: 'Nạp',
    setting: 'Thiết lập',
    default: 'Mặc định',
    list: 'Danh sách',
    addDetail: 'Thêm dòng',
    addDetailShortKey: 'Thêm dòng (F9)',
    import: 'Nhập khẩu',
    logout: 'Đăng xuất',
    next: 'Tiếp theo',
    back: 'Quay lại',
    move: 'Di chuyển',
    minimize: 'Thu gọn',
    TextNameGroup: 'Nhập tên nhóm',
    NameGroup: 'Tên nhóm',
    TextDescription: 'Nhập mô tả',
    DescriptionGroup: 'Mô tả nhóm',
    saveDraft: 'Lưu dự thảo',
    deleteTaskType: 'Xóa loại việc',
    deletePriorityLevel: 'Xóa mức độ ưu tiên',
    deleteTaskTypeSuccess: 'Xóa loại việc thành công',
    columnConfig: 'Thiết lập cột',
    deletePriorityLevelSuccess: 'Xóa mức độ ưu tiên thành công',
    setDefaultValueSuccess: 'Đã chọn lại giá trị mặc định',
    markReadAllNotify: 'Đánh dấu đã đọc tất cả thông báo',
    quickFilter: 'Lọc nhanh',
    settingNotify: 'Thiết lập nhận thông báo',
    sendRequest: 'Đề xuất'
  },
  DashBoard: {
    Params: 'Tham số',
    GetDefault: 'Lấy lại mặc định',
    ToDate: 'Đến ngày',
    PeriodFist: 'Thời gian kỳ 1',
    PeriodSecond: 'Thời gian kỳ 2',
    Year: 'Năm',
    SortType: 'Hướng sắp xếp',
    FromDate: 'Từ ngày',
    Cancel: 'Hủy bỏ',
    Increament: 'Tăng dần',
    Decreament: 'Giảm dần',
    Executor: 'Chủ trì',
    Supervisor: 'Phụ trách',
    Assigner: 'Giao việc',
    Combination: 'Phối hợp',
    Involved: 'Người liên quan',
    Week: 'Tuần',
    Month: 'Tháng',
    Quarter: 'Quý',
    Custom: 'Tùy chọn'
  },
  List: {
    SearchEmptyText: 'Tìm kiếm'
  },
  module: {
    employee: 'Nhân viên',
    employeeType: 'Loại cán bộ',
    payrollItem: 'Khoản lương',
    inventoryItem: 'Vật tư, Hàng hóa',
    buPlanWithDraw: 'Rút dự toán tiền gửi',
    bUTransfer: 'Chuyển khoản kho bạc vào tài khoản tiền gửi',
    accountingObject: 'Cán bộ',
    department: 'Phòng/ban',
    account: 'Tài khoản',
    currency: 'Loại tiền',
    baWithdraw: 'Chi tiền gửi',
    inventoryCategory: 'Loại vật tư, hàng hóa',
    stock: 'Kho',
    buPlanReceipt: 'Nhận dự toán',
    budgetChapter: 'Chương',
    budgetProvide: 'Mã dự phòng',
    typeOfFund: 'Loại quỹ',
    bankInfoCategory: 'Loại tài khoản tiền gửi kho bạc',
    budgetGroupItem: 'Nhóm mục chi',
    budgetSourceProperty: 'Tính chất nguồn kinh phí',
    cAReceipt: 'Phiếu thu',
    budgetSource: 'Nguồn kinh phí',
    bankInfo: 'Tài khoản ngân hàng, kho bạc',
    bUVoucherList: 'Bảng kê chứng từ thanh toán',
    budgetItem: 'Mục - Tiểu mục',
    bUPlanAdjustment: 'Điều chỉnh dự toán',
    budgetKindItem: 'Loại - Khoản',
    sUTransfer: 'Điều chuyển CCDC',
    sUIncrement: 'Ghi tăng CCDC',
    sUDecrement: 'Ghi giảm CCDC',
    bUPlanWDAdjustment: 'Điều chỉnh kinh phí',
    pUInvoice: 'Hóa đơn mua hàng',
    iNTransfer: 'Chuyển kho',
    iNAdjustment: 'Điều chỉnh tồn kho',
    statistic: 'Mã thống kê',
    purchasePurpose: 'Nhóm HH, DV mua vào',
    cAPayment: 'Phiếu chi',
    budgetFees: 'Phí, lệ phí',
    accountTransfer: 'Tài khoản kết chuyển',
    bADeposit: 'Phiếu thu',
    sAInvoice: 'Bán hàng chưa thu tiền',
    bABankTransfer: 'Chuyển tiền nội bộ',
    bUBudgetReserve: 'Dự toán giữ lại',
    gLVoucher: 'Chứng từ nghiệp vụ khác',
    activity: 'Hoạt động',
    task: 'Nhiệm vụ',
    customerVendor: 'Khách hàng, nhà cung cấp',
    accountingObjectCategory: 'Loại khách hàng, nhà cung cấp',
    invoiceFormNumber: 'Mẫu số hóa đơn',
    voucherType: 'Loại chứng từ',
    sAReturn: 'Hàng bán trả lại',
    bUCommitmentRequest: 'Đề nghị cam kết chi',
    bUCommitmentAdjustment: 'Điều chỉnh cam kết chi',
    bUOpeningCommitment: 'Nhập cam kết chi ban đầu',
    project: 'Dự án',
    targetProgram: 'Chương trình mục tiêu',
    projectBudgetDetail: 'Chi tiết tổng mức đầu tư',
    contract: 'Hợp đồng',
    topic: 'Đề tài',
    gLVoucherList: 'Bảng tổng hợp chứng từ',
    workItem: 'Công trình, HMCT',
    BUTransferPurchase: 'Chuyển khoản kho bạc mua vật tư hàng hóa',
    INInwardFromINAdjustment: 'Nhập kho từ điều chỉnh tồn kho',
    INInwardFromINAdjustmentChangeAmount:
      'Nhập kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)',
    INOutwardFromINAdjustment: 'Xuất kho từ điều chỉnh tồn kho',
    INOutwardFromINAdjustmentChangeAmount:
      'Xuất kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)',
    FAVoucherDepreciation: 'Lấy hao mòn tự nhiên TSCĐ từ QLTS.VN',
    FAVoucherIncreament: 'Ghi tăng TSCĐ từ QLTS.VN',
    FAVoucherAdjustment: 'Đánh giá lại TSCĐ từ QLTS.VN',
    FAVoucherDepreciate: 'Lấy khấu hao TSCĐ từ QLTS.VN',
    FAVoucherDecrement: 'Ghi giảm TSCĐ từ QLTS.VN',
    bATransfer: 'Tiền đang chuyển',
    bUPlanImport: 'Nhập dự toán',
    cRERepList: 'Báo cáo tài chính',
    openingSupplyEntry: 'Công cụ dụng cụ',
    autoBusiness: 'Định khoản tự động',
    fundStructure: 'Cơ cấu vốn',
    cRERepExportList: 'Nộp báo cáo cho kho bạc',
    defaultAccount: 'Tài khoản ngầm định',
    cRERepSettlement: 'Báo cáo quyết toán',
    cAReceiptSale: 'Thu tiền khách hàng',
    salaryScale: 'Ngạch lương',
    pAOption: 'Quy định lương, thuế, bảo hiểm',
    toolType: 'Loại công cụ dụng cụ',
    toolList: 'Công cụ dụng cụ',
    jobTitle: 'chức vụ/chức danh'
  },
  Paging: {
    ToAndFrom: '{fromIndex} - {toIndex} bản ghi'
  },
  Title: {
    AddMember: 'Thêm thành viên',
    AddGroupTask: 'Thêm nhóm giao việc',
    UpdateGroupTask: 'Sửa nhóm giao việc'
  },
  Notification: {
    Continue: 'Bạn muốn tiếp tục?',
    Approve: {
      Title: 'Phê duyệt công việc',
      Confirm:
        'Khi thực hiện thao tác này, công việc sẽ được đồng ý với yêu cầu phê duyệt'
    },
    SendApproval: {
      Title: 'Gửi phê duyệt',
      Confirm:
        'Tiến độ hoàn thành công việc của bạn sẽ được cập nhật thành 100%. Bạn muốn tiếp tục?'
    },
    Revoke: {
      Title: 'Thu hồi phê duyệt',
      Confirm:
        'Yêu cầu phê duyệt công việc của bạn sẽ được thu hồi lại. Bạn muốn tiếp tục?'
    },
    CancelApproval: {
      Title: 'Hủy phê duyệt',
      Confirm:
        'Thực hiện thao tác này sẽ hủy kết quả phê duyệt của công việc. Bạn muốn tiếp tục?'
    },
    CancelApprovalChildTask: {
      Title: 'Bỏ đánh dấu hoàn thành',
      Confirm:
        'Khi thực hiện thao tác này, công việc đã được phê duyệt sẽ bị hủy kết quả phê duyệt'
    },
    Authori: {
      Title: 'Xóa người được ủy quyền',
      TextAuthori: 'sẽ bị xóa khỏi danh sách được ủy quyền.'
    },
    AssignmentGroup: {
      Title: 'Xóa nhóm giao việc',
      Text1: 'Nhóm giao việc',
      Text2: 'sẽ bị xóa khỏi hệ thống.',
      DeleteUserContent:
        'Thành viên <b>{FullName}</b> sẽ bị xóa khỏi nhóm giao việc. Bạn muốn tiếp tục?',
      DeleteUser: 'Xóa thành viên'
    },
    Setting: {
      Description:
        'Thiết lập các thông báo theo từng vai trò trong công việc. Các thông báo được bật sẽ hiển thị trong danh sách thông báo của bạn.',
      OnNotify: 'Nhận thông báo',
      OffNotify: 'Không nhận thông báo',
      Assigner: 'Người giao việc',
      Supervisor: 'Người phụ trách',
      Executor: 'Người chủ trì',
      Combination: 'Người phối hợp',
      PeopleInvolved: 'Người liên quan',
      SaveSuccess: 'Thiết lập thông báo thành công'
    }
  },
  ResultSuccess: {
    AddUserAuthori: 'Thêm người ủy quyền thành công',
    DeleteUserAuthori: 'Xóa người ủy quyền thành công',
    DeleteData: 'Xóa dữ liệu thành công',
    DeleteGroup: 'Xóa nhóm giao việc thành công',
    AddData: 'Thêm dữ liệu thành công',
    UpdateDate: 'Cập nhật dữ liệu thành công'
  },
  ReminderTask: {
    Note:
      'Lưu ý: Nếu không chọn giờ bắt đầu hoặc kết thúc thì mặc định bắt đầu vào 08:00 và kết thúc vào 17:30',
    BeforeStartDate: 'Nhắc trước khi bắt đầu',
    BeforeEndDate: 'Nhắc trước khi hết hạn',
    SpecificTime: 'Nhắc vào thời điểm cụ thể',
    SaveSuccess: 'Lưu nhắc việc thành công'
  },

  UpdateDeadlinePopup: {
    SaveSuccess: 'Đề xuất hạn hoàn thành thành công',
    UpdateSuccess: 'Cập nhật đề xuất hạn hoàn thành thành công',
    DeleteSuccess: 'Đã cập nhật hạn hoàn thành mới',
    Approved: 'Đã cập nhật hạn hoàn thành mới',
    Rejected: 'Đã từ chối đề xuất'
  },
  InvalidStartDate:
    'Ngày bắt đầu phải nhỏ hơn hạn hoàn thành. Vui lòng thiết lập lại',
  InvalidStartDateAndEndDate: 'Ngày bắt đầu không được lớn hơn ngày kết thúc',
  RequireStartDateAndEndDate: 'Vui lòng nhập ngày bắt đầu và ngày kết thúc',
  InvalidRemoveFilter: 'Không thể xóa nếu chỉ còn một bộ lọc duy nhất',
  After: 'Sau',
  Before: 'Trước',
  DuplicateTimeStartDate: 'Giờ bắt đầu phải nhỏ hơn giờ kết thúc ',
  InvalidSpecificTime: 'Bạn chưa chọn ngày nhắc việc',
  AddExecutor: 'Thêm người/đơn vị chủ trì',
  AddCombination: 'Thêm người/đơn vị phối hợp',
  AddAssigner: 'Thêm người giao việc',
  AddSupervisor: 'Thêm người phụ trách',
  AddPeopleInvolved: 'Thêm người liên quan',
  AddTaskSupervisor: 'Thêm người phụ trách',
  Member: 'Thành viên',
  UserGroupName: 'Tên nhóm',
  UserGroupDesc: 'Mô tả nhóm',
  OrganizationUnit: 'Đơn vị',
  Department: 'Phòng ban',
  SelectOrganizationUnit: 'Chọn đơn vị',
  SelectExecOrganizationUnit: 'Chọn đơn vị chủ trì',
  SelectDepartment: 'Chọn phòng ban',
  SelectDepartmentNew: 'Chọn phòng ban mới',
  OrganizationUnitName: 'Tên đơn vị',
  SearchByOrgUnitName: 'Tìm theo tên đơn vị',
  SearchByUserGroupName: 'Tìm theo tên nhóm',
  SearchByUserName: 'Tìm theo họ và tên',
  AddTask: 'Thêm công việc',
  Reminder: 'Nhắc việc',
  UpdateDeadline: 'Đề xuất hạn hoàn thành',
  DeadlineApprover: 'Người phê duyệt',
  AddDeadlineApprover: 'Chọn người phê duyệt',
  EnterReasonDeadline: 'Nhập lý do',
  Request: 'Đề xuất',
  TypingUpdateDeadline: 'Chọn thời gian đề xuất',
  SendMultipleTasks: 'Giao việc hàng loạt',
  TypingTaskName: 'Nhập tên công việc',
  TypingChildTaskName: 'Nhập tên công việc con',
  TaskName: 'Tên công việc',
  DescriptionTask: 'Mô tả',
  PriorityLevelName: 'Tên mức độ ưu tiên',
  TaskType: 'Tên loại việc',
  WorkType: 'Loại việc',
  TaskOwner: 'Người giao việc',
  TaskSupervisor: 'Người phụ trách',
  TaskDesc: 'Mô tả',
  TaskExecutor: 'Người/Đơn vị chủ trì',
  TaskCoordinators: 'Người/Đơn vị phối hợp',
  TaskLogExecutor: 'Người chủ trì',
  TaskLogCoordinators: 'Người phối hợp',
  AssignFile: 'Tệp giao việc',
  TaskPeopleInvolveds: 'Người liên quan',
  TaskPriority: 'Mức độ ưu tiên',
  TypingDesc: 'Nhập mô tả',
  TaskDocument: 'Văn bản chỉ đạo',
  TaskDocumentSigner: 'Người ký ban hành',
  TypingDocumentCode: 'Nhập số văn bản',
  TypingDocumentDate: 'Chọn ngày ban hành',
  TypingDocumentSigner:
    'Nhập Họ tên - Chức vụ - Đơn vị công tác của người ký ban hành',
  DeleteTaskDocument: 'Xóa văn bản',
  TypingTaskDocument: 'Nhập văn bản chỉ đạo',
  TypingStartDate: 'Chọn ngày bắt đầu',
  TypingReminder: 'Chọn thời điểm nhắc lịch',
  TypingDeadline: 'Chọn hạn hoàn thành',
  TypingUpdateDeadline: 'Chọn thời gian đề xuất',
  MoreReminder: 'Nhiều lời nhắc',
  Or: 'hoặc',
  ChooseTaskDocumentFromList: 'Chọn từ danh sách',
  Personal: 'Cá nhân',
  WorkGroup: 'Nhóm giao việc',
  SaveDraftSuccessMsg: 'Lưu dự thảo công việc thành công',
  SaveSuccessMsg: 'Lưu công việc thành công',
  SendSuccessMsg: 'Gửi công việc thành công',
  ErrorOccurMsg: 'Có lỗi xảy ra',
  EditVersionErrorMsg:
    'Công việc này mới được chỉnh sửa từ một người khác. Vui lòng mở lại công việc',
  NotAllowViewTaskErrorMsg: 'Bạn không có quyền xem công việc này',
  SelectUserModeNotify:
    'Hệ thống sẽ nhân bản công việc theo số người chủ trì tương ứng',
  TaskCannotBeModifyByOutOfDateMsg:
    'Công việc đã vượt quá hạn cho phép, vui lòng liên hệ người giao việc gia hạn hoàn thành để thực hiện tiếp công việc.',
  TaskCannotBeSendApprovalByOutOfDateErrorMsg:
    'Không thể gửi phê duyệt do công việc đã vượt quá hạn cho phép',
  TaskCannotBeAddFileByOutOfDateErrorMsg:
    'Không thể thêm tệp do công việc đã vượt quá hạn cho phép',
  TaskCannotBeAddChildrenTaskByOutOfDateErrorMsg:
    'Không thể thêm công việc con do công việc đã vượt quá hạn cho phép',
  ChildrenTask: 'Công việc con',
  AddChildrenTask: 'Thêm công việc con',
  WatchDetailChildTask: 'Chi tiết công việc con',
  DetailTaskTitle: 'Chi tiết công việc',
  DraftStatus: 'Dự thảo',
  RequiredChildTaskName: 'Tên công việc con không được để trống',
  RequiredChildTaskExecutor:
    'Người/Đơn vị chủ trì của công việc con không được để trống',
  BackToParent: 'Xem công việc cha',
  ForwardTask: 'Chuyển tiếp',
  PreviewForwardTask: 'Xem trước',
  ForwardTaskTitle: 'Chuyển tiếp công việc',
  ForwardTaskDesc:
    'Hệ thống sẽ tạo công việc với nội dung tương tự và giao cho Người/Đơn vị được chọn dưới đây',
  ForwardTaskShareAttachmentLabel:
    'Chia sẻ tất cả bộ tệp đính kèm cho công việc này',
  DeleteSavedTaskMsg: 'Công việc sẽ bị xóa khỏi hệ thống. Bạn muốn tiếp tục?',
  DeleteSavedSavedTaskMsg:
    'Sau khi thực hiện xóa công việc, tất cả các dữ liệu liên quan bao gồm: thông tin mô tả công việc, tài liệu đính kèm, các công việc con, bình luận, lịch sử hoạt động... sẽ bị xóa khỏi hệ thống. Bạn muốn tiếp tục?',
  DeleteTaskSuccessMsg: 'Xóa công việc thành công',
  SendParentTaskBeforeSendChildTaskMsg:
    'Bạn phải gửi công việc cha trước khi gửi công việc con',
  ChildTaskDeadlineCannotBeGreaterThenParent:
    'Hạn hoàn thành công việc con không thể lớn hơn công việc cha',
  SaveDraftParentTaskBeforeSaveDraftChildTaskMsg:
    'Bạn phải lưu dự thảo công việc cha trước lưu dự thảo công việc con',
  NowAllowSendParentTaskBecauseChildrenTaskInvalid:
    'Không thể gửi công việc cha do vẫn còn công việc con thiếu thông tin',
  NowAllowSaveDraftParentTaskBecauseChildrenTaskInvalid:
    'Không thể lưu dự thảo công việc cha do vẫn còn công việc con thiếu thông tin',
  DeleteFile: 'Xóa tệp',
  confirmDelete: 'sẽ bị xóa khỏi hệ thống. Bạn muốn tiếp tục?',
  NotificationTitle: 'Thông báo',
  SettingNotificationTitle: 'Thiết lập thông báo',
  ConfirmBeforeClose: 'Dữ liệu đã thay đổi, bạn có muốn lưu lại không?',
  TaskProcessText: 'Tiến độ',
  SaveTaskProcessSuccess: 'Cập nhật tiến độ công việc thành công',
  CancelDoneTaskSuccess: 'Hủy đánh dấu hoàn thành công việc thành công',
  CancelDoneTask: 'Hủy đánh dấu hoàn thành',
  SaveTaskProportionSuccess: 'Cập nhật tỷ trọng công việc thành công',
  TaskProcessDoneText: 'Đã hoàn thành',
  WarningText: 'Cảnh báo',
  WarningChildTaskDeadlineMoreThanParent:
    'Hạn hoàn thành của công việc con đang lớn hơn hạn hoàn thành của công việc cha. Bạn có chắc muốn thực hiện thao tác này không?',
  ExpandText: 'Mở rộng',
  MarkTaskAsDoneMessage:
    'Khi thực hiện thao tác này, công việc sẽ được đánh dấu là hoàn thành',
  MarkApprovalAsDoneMessage:
    'Khi thực hiện thao tác này, công việc sẽ được đồng ý với yêu cầu phê duyệt',
  MarkTaskAsDoneTitle: 'Đánh dấu hoàn thành',
  UnmarkTaskAsDoneMessage:
    'Khi thực hiện thao tác này, công việc sẽ được đánh dấu là hoàn thành',
  UnmarkTaskAsDoneTitle: 'Bỏ đánh dấu hoàn thành',
  All: 'Tất cả',
  Comment: 'Bình luận',
  Activity: 'Lịch sử hoạt động',
  SeeMore: 'Xem thêm',
  SeeMoreActivity: 'Xem thêm lịch sử hoạt động...',
  Reason: 'Lý do',
  NotRating: 'Chưa đánh giá',
  ApproveComment: 'Nhận xét: {reason}',
  ApproveReason: 'Lý do: {reason}',
  NotFinishReason: 'Lý do trễ hạn: {reason}',
  UpdateTaskChildProcess:
    'do công việc <b>{taskChildName}</b> được cập nhật tiến độ hoàn thành.',
  From: 'từ',
  To: 'thành',
  TIME_MINUTE_AGO: 'phút trước',
  TIME_HOUR_AGO: 'giờ trước',
  TIME_JUST_NOW: 'Vừa xong',
  TIME_DAY_AGO: 'ngày trước',
  TIME_WEEK_AGO: 'tuần trước',
  DeleteTask: 'Xóa công việc',
  EditTask: 'Chỉnh sửa',
  WarningSelectUserSingleMsg:
    'Không thể giao việc cho <strong>{organizationUnitName}</strong> do đơn vị này chưa có Trưởng, Phó bộ phận',
  WarningSelectUserMultipleMsg:
    'Không thể giao việc cho các đơn vị sau do chưa có Trưởng, Phó bộ phận',
  WarningSelectUserAssigmentMsg:
    'Không thể thêm vào nhóm giao việc các đơn vị sau do chưa có Trưởng, Phó bộ phận',
  WarningSelectUserFilterMsg:
    'Không thể chọn <strong>{organizationUnitName}</strong> do các đơn vị này chưa có Trưởng, Phó bộ phận',
  DeleteUser: 'Xóa người dùng',
  sendedApproval: 'đã gửi yêu cầu phê duyệt',
  enterComment: 'Nhập vào nhận xét',
  enterReason: 'Nhập vào lý do từ chối',
  enterOutTimeReason: 'Nhập vào lý do quá hạn',
  you: 'Bạn',
  updateRatingStar: 'Đánh giá công việc thành công',
  suggestRatingStar:
    'Mức độ nên đánh giá dựa theo thiết lập đánh giá công việc',
  approvedTask: 'đã phê duyệt công việc',
  doneTask: 'đã đánh dấu hoàn thành công việc',
  rejectedTask: 'đã từ chối công việc',
  viewComment: 'Xem nhận xét',
  addComment: 'Thêm nhận xét',
  viewReason: 'Xem lý do từ chối',
  addReason: 'Thêm lý do từ chối',

  FullNameLabel: 'Họ và tên',
  JobTitleLabel: 'Chức vụ/Chức danh',
  PositionLabel: 'Vị trí',
  DepartmentLabel: 'Phòng ban',
  StatusLabel: 'Trạng thái',
  CreatedLabel: 'Ngày tạo',
  UserManual: 'Bắt đầu sử dụng',
  HideUserManual: 'Ẩn bắt đầu sử dụng',
  AgreementLicenseSuccess: 'Xác nhận thỏa thuận thành công',
  AgreementLicenseFail: 'Xác nhận thỏa thuận thất bại',
  Version: 'Phiên bản thỏa thuận',
  AgreementDate: 'Thời điểm thỏa thuận',
  AgreementContactName: 'Họ tên người đại diện',
  ContactTitle: 'Chức vụ người đại diện',
  ContactMobile: 'Số điện thoại',
  ContactEmail: 'Email',
  Functional: 'Chức năng',
  ReadAgreementLicense: 'Đọc thỏa thuận sử dụng phần mềm',
  EnterInfoAgreement: 'Điền thông tin người xác nhận thỏa thuận',
  ConfirmAgreementLicense: 'Tôi đã đọc và đồng ý với thỏa thuận sử dụng',
  AgreementLicenseNote:
    'Thông tin này để xác nhận thỏa thuận<br>sử dụng hợp đồng với MISA.',
  AcceptAgreementLicense:
    'Tôi đồng ý với các điều khoản trong Thỏa thuận sử dụng và Chính sách quyền riêng tư',
  login: {
    startLoginMessage: 'Đăng nhập để làm việc với ',
    misaTaskGo: 'MISA TaskGo',
    copyright: 'Copyright © 2021 - {0} MISA JSC',
    buttonText: 'Đăng nhập',
    emailOrPhoneNumber: 'Email',
    password: 'Mật khẩu',
    forgotPassword: 'Quên mật khẩu',
    twofactor: 'Xác thực 2 yếu tố',
    goBack: 'Quay lại đăng nhập'
  },
  twoFactor: {
    app:
      'Nhận mã xác thực từ ứng dụng <b>Google Authenticator</b> mà bạn đã cài đặt trên thiết bị của bạn',
    anotherWay: 'Thử cách khác',
    remember: 'Không hỏi lại trên thiết bị này'
  },
  anotherWay: {
    app:
      'Nhận mã xác thực từ Ứng dụng <b>Google Authenticator</b> mà bạn đã thiết lập',
    email: 'Nhận mã xác thực qua email',
    phoneNumber: 'Nhận mã xác thực qua số điện thoại',
    title: 'Thử cách nhận mã xác thực khác',
    misaHelp: 'Nhận trợ giúp từ MISA'
  },
  CategoryLabel: 'Hạng mục',
  ViewRoleLabel: 'Xem',
  EditRoleLabel: 'Sửa',
  TopNav: {
    Notify: 'Thông báo',
    Help: 'Hướng dẫn'
  },
  importFileName: {
    Task: {
      ErrorFileName: 'File_loi_nhap_khau_cong_viec',
      ValidateResultFileName: 'File_ket_qua_kiem_tra_nhap_khau_cong_viec'
    },
    User: {
      ErrorFileName: 'File_loi_nhap_khau_nguoi_dung',
      ValidateResultFileName: 'File_ket_qua_kiem_tra_nhap_khau_nguoi_dung'
    }
  },
  FileDoesNotContainDataImport: 'Tệp không có dữ liệu nhập khẩu',
  Other: 'Khác',

  TopNavMoreAction: {
    StartUsing: 'Bắt đầu sử dụng',
    TourGuide: 'Khám phá',
    SurveyCustomer: 'Đánh giá độ hài lòng',
    TermsOfService: 'Thỏa thuận dịch vụ',
    PrivacyPolicy: 'Chính sách bảo mật',
    Privacy: 'Chính sách quyền riêng tư',
    Agreements: 'Thỏa thuận mua hàng'
  }
};
